module.exports = __webpack_public_path__ + "school/img/beike3ji.1a3344fb.jpg";